import React from 'react';
import { PMCConfig } from '@kyruus/types';
import { useIntl } from '@kyruus/intl';
import type { Log } from 'Src/types';
import type { GetUpdatedSearch, SearchModification } from 'Src/types/search';
import { getConfigProperty } from 'Common/config';
import { SearchChip, SearchChipSection } from './SearchChipSection';
import { messages } from './messages';
import { DEFAULT_COMMON_SEARCHES } from './constants';
import { getCommonSearchMessageDescriptor } from './utils';

const COMMON_SEARCHES_HEADING_ID = 'noResultsCommonSearchesHeading';

interface CommonSearchesProps {
  baseQueryMods: SearchModification[];
  config: PMCConfig;
  getUpdatedSearch: GetUpdatedSearch;
  log: Log;
}
export const CommonSearches = ({
  baseQueryMods,
  config,
  getUpdatedSearch,
  log
}: CommonSearchesProps) => {
  const intl = useIntl();

  const handleClick = (searchTerm: string) => {
    log('user_action.no_results.common_search_clicked', {
      term: searchTerm
    });
  };
  const commonSearches: string[] = getConfigProperty(
    config,
    'no_results_page.common_searches',
    DEFAULT_COMMON_SEARCHES
  );
  return (
    <SearchChipSection
      heading={intl.formatMessage(messages.commonSearchesHeading)}
      headingId={COMMON_SEARCHES_HEADING_ID}
    >
      {commonSearches.map((searchTerm) => (
        <SearchChip
          key={searchTerm}
          label={intl.formatMessage(
            getCommonSearchMessageDescriptor(searchTerm)
          )}
          onClick={() => handleClick(searchTerm)}
          queryModifications={[
            ...baseQueryMods,
            {
              action: 'append',
              key: 'unified',
              value: searchTerm
            }
          ]}
          getUpdatedSearch={getUpdatedSearch}
        />
      ))}
    </SearchChipSection>
  );
};
